import {
    APP_INIT,
    APP_LOADED,
    // SETTINGS_SUCCESS,
    MODAL_HIDE,
    MODAL_SHOW,
    SNACKBAR_HIDE,
    SNACKBAR_SHOW,
    SIDE_NAV_TYPE,
    LOCALE_REQUEST,
    LOCALE_SUCCESS,
    CHANGE_LANG,
    SETTINGS_SUCCESS,
    // SHOW_COOKIE_CONSENT,
    // HIDE_COOKIE_CONSENT,
} from "types";

import { AnyAction } from "redux";

import { rs } from "helpers/reducers";

interface IState {
    loaded: boolean;
    modals: Array<{
        id: string;
    }>;
    request: any;
    settings: any;
    snackbar: any;
    sideNavType: string;
    lang: string;
    errorMessage: string;
}
function general(
    state: IState = {
        loaded: false,
        modals: [],
        request: {},
        settings: {},
        snackbar: null,
        sideNavType: "main",
        lang: "",
        errorMessage: "",
    },
    action = {} as AnyAction
) {
    switch (action.type) {
        case APP_INIT:
            return rs.init(state);

        case APP_LOADED:
            return {
                ...state,
                loaded: true,
                errorMessage: action.errorMessage || "",
            };
        case SETTINGS_SUCCESS:
            return {
                ...state,
                settings: action.response.data,
            };
        case MODAL_HIDE:
            return {
                ...state,
                modals: state.modals.filter((modal) => modal.id !== action.id),
            };

        case MODAL_SHOW:
            const modalAlreadyOpened = state.modals.find((item: any) => item.id === action.id)
            if (modalAlreadyOpened) return state
            else return {
                ...state,
                modals: [
                    ...state.modals,
                    {
                        id: action.id,
                        props: action.props,
                    },
                ],
            };

        case SNACKBAR_HIDE:
            return {
                ...state,
                snackbar: null,
            };
        case SNACKBAR_SHOW:
            return {
                ...state,
                snackbar: action.data,
            };
        case SIDE_NAV_TYPE:
            return {
                ...state,
                sideNavType: action.data,
            };
        case LOCALE_REQUEST:
            return {
                ...state,
                loaded: false,
            };
        case LOCALE_SUCCESS:
            return {
                ...state,
                loaded: true,
            };
        case CHANGE_LANG:
            return {
                ...state,
                lang: action.data,
            };
        default:
            return state;
    }
}

export default general;
